export const LANDING_TEXT = {
  heroTitle: "Personalised Visual Meditation Guide",
  heroSubtitle: "A calm, guided experience built for your mind.",
  welcome: "Welcome",
} as const;
